import React from "react";
import { Pill } from "../../common/DataList";
import ConsommationQuota from "../Operateurs/ConsommationQuota";
import { communesTexte, etatRegle, liste, majuscule, phrasePublic } from "./reglesSousOrientation";

// ============================================================
// Les règles d'une version, dans l'ordre (CE-1419, maquette 11) : une ligne
// par règle, lisible comme une phrase — le public en titre, les communes
// dessous, les opérateurs, puis la consommation du quota FSE+ de l'année ou
// la raison pour laquelle la règle est passée. La couleur ne marque que
// l'exception. « Tous les autres restent à la Caf » ferme la liste.
// ============================================================

const ICONE_NOTE = { ko: "fa-times-circle", warn: "fa-exclamation-triangle" };

const ListeRegles = ({ regles, annee, peutModifier, onModifier }) => (
  <>
    <div className="regle regle--entete" aria-hidden="true">
      <span />
      <span>Allocataires concernés</span>
      <span>Vers</span>
      <span className="regle__quota">Mesures {annee}</span>
      <span />
    </div>
    <ol className="regles">
      {regles.map((regle) => {
        const etat = etatRegle(regle, annee);
        const titre = majuscule(phrasePublic(regle.criteres));
        return (
          <li key={regle.id} className={`regle${etat.ton !== "ok" ? ` regle--${etat.ton}` : ""}`}>
            <span className="regle__rang" aria-hidden="true">
              {regle.rang}
            </span>
            <div className="regle__qui">
              <span className="sr-only">Règle {regle.rang} : </span>
              {peutModifier ? (
                <button type="button" className="regle__titre" onClick={() => onModifier(regle)}>
                  {titre}
                </button>
              ) : (
                <span className="regle__titre">{titre}</span>
              )}
              <span className="regle__sous">{communesTexte(regle.communes)}</span>
            </div>
            <div className="regle__vers">
              <b>{liste(regle.operateurs.map((o) => o.nom), "et")}</b>
              <span className="regle__sous">{regle.operateurs.length > 1 ? "à parts égales · FSE+" : "FSE+"}</span>
            </div>
            <div className="regle__quota">
              {etat.pastille ? (
                <Pill tone={etat.ton} icon={etat.pastille.icone}>
                  {etat.pastille.libelle}
                </Pill>
              ) : (
                <ConsommationQuota utilisees={etat.utilisees} quota={etat.quota} />
              )}
            </div>
            {peutModifier ? (
              <button type="button" className="btn btn-ghost btn-icon" onClick={() => onModifier(regle)} aria-label={`Modifier la règle ${regle.rang}`} title="Modifier">
                <i className="fa fa-pen" aria-hidden="true" />
              </button>
            ) : (
              <span />
            )}
            {etat.note && (
              <p className={`regle__note regle__note--${etat.ton}`}>
                <i className={`fa ${ICONE_NOTE[etat.ton]}`} aria-hidden="true" />
                {etat.note}
              </p>
            )}
          </li>
        );
      })}
    </ol>
    <div className="regle regle--defaut">
      <span className="regle__rang" aria-hidden="true">
        <i className="fa fa-arrow-right" />
      </span>
      <div className="regle__qui">
        <span className="regle__titre">Tous les autres</span>
      </div>
      <div className="regle__vers">
        <b>Restent à la Caf</b>
      </div>
    </div>
  </>
);

export default ListeRegles;
